var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tui-loading",style:({
    width: _setup.props.width,
    height: _setup.props.height,
    border: `2px solid ${_setup.props.color}`,
    borderTopColor: 'transparent',
  })})
}
var staticRenderFns = []

export { render, staticRenderFns }